import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const NumberOfEmpowermentTrainingsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Number of empowerment trainings conducted" />
    </Box>
  );
};
